import { menuAnatomy as menuAnatomyParts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { colors, textStyles } from "../../../../theme/foundations/generated";
import { headerHeight } from "../../../organisms/Header/theme/Header.default";
const parts = [
    "buttonTitle",
    "indicator",
    "rightIcon",
    "button",
    "groupTitle",
    ...menuAnatomyParts.keys,
];
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts);
const baseStyle = definePartsStyle({
    button: {
        maxWidth: "100%",
        "> span": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: "100%",
        },
    },
    indicator: {
        ml: "auto",
        pl: "1",
    },
    buttonTitle: {
        mr: "2",
        display: { base: "none", md: "initial" },
    },
    item: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        ".chakra-text": textStyles.body.mediumDemibold,
    },
    rightIcon: {
        marginLeft: "auto",
    },
    icon: {
        height: "6",
        mr: "2",
    },
});
// Variants
const normal = definePartsStyle({
    button: {
        pr: "1.5rem",
        pl: "1.5rem",
        py: "7",
        color: "semantic.text.inverse",
        backgroundColor: "semantic.foreground.primary",
        _hover: {
            color: "semantic.text.primary",
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _active: {
            color: "semantic.text.inverse",
            backgroundColor: "semantic.cta.secondaryPressed",
            _expanded: {
                color: "semantic.text.inverse",
                backgroundColor: "semantic.cta.secondaryPressed",
            },
        },
        _focusVisible: {
            color: "semantic.text.primary",
            boxShadow: `inset 0 0 0 3px ${colors.semantic.outline.focus}`,
            backgroundColor: "semantic.cta.secondaryHover",
        },
    },
    buttonTitle: textStyles.body.mediumDemibold,
    list: {
        boxSizing: "unset",
        boxShadow: "large",
        borderRadius: "none",
        border: "1px solid",
        borderColor: "semantic.border.secondary",
        p: "0",
        width: "17.6875rem",
    },
    item: {
        borderRadius: "none",
        px: "2",
        py: "3",
        height: "2.75rem",
        width: "17.6875rem",
        backgroundColor: "semantic.surface.1",
        color: "semantic.text.primary",
        _focusVisible: {
            color: "semantic.text.primary",
            boxShadow: `inset 0 0 0 3px ${colors.semantic.outline.focus}`,
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _hover: {
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _active: {
            color: "semantic.text.inverse",
            backgroundColor: "semantic.cta.secondaryPressed !important",
            _expanded: {
                color: "semantic.text.inverse",
                backgroundColor: "semantic.cta.secondaryPressed !important",
            },
        },
        _disabled: {
            _hover: {
                backgroundColor: "semantic.surface.1",
            },
        },
    },
    groupTitle: Object.assign(Object.assign({ color: "semantic.text.primary" }, textStyles.body.largeBold), { p: "1rem .5rem .5rem", m: 0 }),
});
const dataTable = definePartsStyle(Object.assign(Object.assign({}, normal), { button: {
        width: "3.5rem",
        height: "3.5rem",
        color: "semantic.interactive.primary",
        _hover: Object.assign(Object.assign({}, normal.button._hover), { color: "semantic.interactive.primary" }),
        _active: {
            color: "semantic.icon.primary",
        },
        _focusVisible: Object.assign({}, normal.button._focusVisible),
    } }));
const cardDropdown = definePartsStyle(Object.assign(Object.assign({}, normal), { item: Object.assign(Object.assign({}, normal.item), { px: "4" }), groupTitle: Object.assign(Object.assign({}, normal.groupTitle), { p: "1rem 1rem .5rem" }) }));
const buttonDropdown = definePartsStyle(Object.assign(Object.assign({}, normal), { item: Object.assign(Object.assign({}, normal.item), { px: "4" }), button: Object.assign({ height: "2.5rem", py: 2, px: 4 }, textStyles.body.mediumBold) }));
const transparent = definePartsStyle(Object.assign(Object.assign({}, dataTable), { button: Object.assign(Object.assign({}, dataTable.button), { _hover: {
            color: "semantic.icon.pressed",
        }, _focusVisible: Object.assign(Object.assign({}, dataTable.button._focusVisible), { backgroundColor: "none" }) }) }));
const companyTabs = definePartsStyle(Object.assign(Object.assign({}, normal), { button: Object.assign(Object.assign({}, normal.button), { height: "4rem", "> span > :first-child": {
            borderRadius: "50%",
            backgroundColor: "semantic.brand.secondary-dimmed",
            color: "semantic.icon.primary",
        }, _hover: Object.assign(Object.assign({}, normal.button._hover), { "> span > :first-child": {
                backgroundColor: "semantic.text.inverse",
            } }) }) }));
const companyTabsBO = definePartsStyle(Object.assign(Object.assign({}, companyTabs), { button: Object.assign(Object.assign({}, companyTabs.button), { "> span > :first-child": {
            borderRadius: "50%",
            backgroundColor: "semantic.brand.tertiary-dimmed",
            color: "semantic.icon.primary",
        } }) }));
const navigation = definePartsStyle({
    button: {
        px: "3",
        height: {
            base: `calc(${headerHeight.base} - 1px)`,
            md: `calc(${headerHeight.md} - 1px)`,
        },
        color: "semantic.text.primary",
        backgroundColor: "transparent",
        borderBottom: "4px solid",
        borderColor: "transparent",
        _hover: {
            borderColor: "semantic.interactive.primary",
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _active: {
            borderColor: "semantic.interactive.primary",
            color: "semantic.text.inverse",
            backgroundColor: "semantic.cta.secondaryPressed",
            _expanded: {
                color: "semantic.text.primary",
                backgroundColor: "transparent",
            },
        },
        _focusVisible: {
            boxShadow: `inset 0 0 0 3px ${colors.semantic.outline.focus}`,
            backgroundColor: "semantic.cta.secondaryHover",
        },
    },
    buttonTitle: textStyles.body.largeDemibold,
    list: {
        boxSizing: "unset",
        boxShadow: "large",
        borderRadius: "none",
        border: "1px solid",
        borderColor: "semantic.border.secondary",
        p: "0",
        width: "22.5rem",
    },
    item: {
        borderRadius: "none",
        px: "6",
        py: "3",
        height: "4.25rem",
        width: "22.5rem",
        backgroundColor: "semantic.surface.1",
        color: "semantic.text.primary",
        _hover: {
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _active: {
            color: "semantic.text.inverse",
            backgroundColor: "semantic.cta.secondaryPressed !important",
            _expanded: {
                color: "semantic.text.inverse",
                backgroundColor: "semantic.cta.secondaryPressed !important",
            },
        },
        _disabled: {
            _hover: {
                backgroundColor: "semantic.surface.1",
            },
        },
    },
});
const headerBar = definePartsStyle({
    button: {
        px: "3",
        py: "7",
        color: "semantic.text.primary",
        backgroundColor: "transparent",
        borderBottom: "4px solid",
        borderColor: "transparent",
        p: {
            textTransform: "capitalize",
        },
        _hover: {
            borderColor: "semantic.interactive.primary",
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _active: {
            borderColor: "semantic.interactive.primary",
            color: "semantic.text.inverse",
            backgroundColor: "semantic.cta.secondaryPressed",
            _expanded: {
                color: "semantic.text.primary",
                backgroundColor: "transparent",
            },
        },
        _focusVisible: {
            boxShadow: `inset 0 0 0 3px ${colors.semantic.outline.focus}`,
            backgroundColor: "semantic.cta.secondaryHover",
        },
    },
    buttonTitle: textStyles.body.largeDemibold,
    list: {
        boxSizing: "unset",
        boxShadow: "large",
        borderRadius: "none",
        border: "1px solid",
        borderColor: "semantic.border.secondary",
        p: "0",
        width: "17.6875rem",
    },
    item: {
        borderRadius: "none",
        px: "2",
        py: "3",
        height: "2.75rem",
        width: "17.6875rem",
        backgroundColor: "semantic.surface.1",
        color: "semantic.text.primary",
        _hover: {
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _active: {
            color: "semantic.text.inverse",
            backgroundColor: "semantic.cta.secondaryPressed !important",
            _expanded: {
                color: "semantic.text.inverse",
                backgroundColor: "semantic.cta.secondaryPressed !important",
            },
        },
        _disabled: {
            _hover: {
                backgroundColor: "semantic.surface.1",
            },
        },
        _focusVisible: {
            color: "semantic.text.primary",
            boxShadow: `inset 0 0 0 3px ${colors.semantic.outline.focus}`,
            backgroundColor: "semantic.cta.secondaryHover",
        },
    },
});
const DropdownMenuTheme = defineMultiStyleConfig({
    baseStyle,
    variants: {
        default: normal,
        companyTabs,
        companyTabsBO,
        navigation,
        headerBar,
        dataTable,
        transparent,
        cardDropdown,
        buttonDropdown,
    },
    defaultProps: {
        variant: "default",
    },
});
export default DropdownMenuTheme;
export { parts };
//# sourceMappingURL=DropdownMenu.default.js.map